<div class="bg-container">
    <app-header></app-header>

    <div class="router-wrapper">
        <router-outlet></router-outlet>
    </div>

    <app-footer [hideVersion]="true"></app-footer>
</div>
